import { render } from "./StatusPanel.vue?vue&type=template&id=2dac1bd1&scoped=true"
import script from "./StatusPanel.vue?vue&type=script&lang=js"
export * from "./StatusPanel.vue?vue&type=script&lang=js"

import "./StatusPanel.vue?vue&type=style&index=0&id=2dac1bd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dac1bd1"]])

export default __exports__